import { Separator } from "@/components/ui/separator";

const FooterSupplierLogos = () => {
  const suppliers = [
    { name: "Epol", logo: "/lovable-uploads/75c7ebb1-f6cd-4bf9-9d50-ab3882310ba6.png" },
    { name: "Jock", logo: "/lovable-uploads/c77ac0a3-43a8-49d6-808f-e23aaf278060.png" },
    { name: "Montego", logo: "/lovable-uploads/598e3b8d-3367-46e1-8790-99bba96dec8a.png" },
    { name: "Nova Feeds", logo: "/lovable-uploads/718c03b3-2cb6-4cff-90c5-ffe90e1b52c3.png" },
    { name: "Nutri Feeds", logo: "/lovable-uploads/150ec617-5f27-4bf0-b1d1-38d670afbd76.png" },
    { name: "Powafix", logo: "/lovable-uploads/95f79000-80d4-410d-ab6c-e91debcb9c6a.png" },
    { name: "Royal Feeds", logo: "/lovable-uploads/ec866f43-b63e-40a5-88c1-9aa3ab6ddd1d.png" },
    { name: "Spurwing Horse Feeds", logo: "/lovable-uploads/7bb258ef-3e2c-43c2-9ed5-6c020bd8da88.png" },
  ];

  return (
    <div className="border-t border-springbok-700 pt-8 pb-6">
      <h4 className="text-center text-lg mb-6 text-gold-400">Our Trusted Suppliers</h4>
      <div className="flex flex-wrap justify-center gap-6">
        {suppliers.map((supplier, i) => (
          <div key={i} className="h-12 w-24 bg-white rounded-lg shadow-sm flex items-center justify-center p-1">
            <img
              src={supplier.logo}
              alt={supplier.name}
              width={96}
              height={48}
              loading="lazy"
              className="max-h-10 max-w-full object-contain opacity-80 hover:opacity-100 transition-opacity"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FooterSupplierLogos;
